import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { transactionPaymentActions } from "../store/actions/transactions/transactionPayment.actions";
import validationHelper from "../utils/helpers/validation.helper";
import alertService from "../services/alert/alert.service";
import LoaderComponent from "../components/LoaderComponent";
import StringsHelper from "../utils/helpers/strings.helper";

export const SetPaymentDetailsSuccessPageComponent = ({ transactionPaymentActions }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAppLoading, setIsAppLoading] = useState();

  useEffect(() => {
    createPatmentToken();
  }, [location.search]);

  const createPatmentToken = async () => {
    setIsAppLoading(true);
    // Params Map: Filed1 = companyId, Field2 = ChargePointId, Filed3 = ClientId
    const queryParams = getQueryParams(location.search);

    const keys = StringsHelper.splitStrings(queryParams.Fild2);
    if (keys.length < 3) {
      alertService.error("שגיאה בהוספת אמצעי תשלום", "אנא נסה שנית מאוחר יותר");
      navigate(`/`);
      return;
    }

    const response = await transactionPaymentActions.createPaymentToken(queryParams);
    if (validationHelper.validateHttpResponse(response) && response.payload) {
      setIsAppLoading(false);
      // Navigate with clientId and paymentTokenId in query params
      navigate(`/company/${keys[0]}/chargePoint/${keys[1]}?clientId=${keys[2]}&paymentTokenId=${response.payload}`);
    } else {
      setIsAppLoading(false);
      alertService.error("שגיאה בשמירת אמצעי התשלום", "אנא נסה להזין שנית את פרטי האשראי");
      // Navigate with clientId in query params
      navigate(`/company/${keys[0]}/chargePoint/${keys[1]}?clientId=${keys[2]}`);
    }
  };

  const getQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const queryParams = {};

    for (let [key, value] of params.entries()) {
      queryParams[key] = decodeURIComponent(value);
    }

    return queryParams;
  };

  if (isAppLoading) return <LoaderComponent />;

  return <div></div>;
};

const mapStateToProps = (state) => ({
  transactionClientReducer: state.transactionClientReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    transactionPaymentActions: bindActionCreators(transactionPaymentActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPaymentDetailsSuccessPageComponent);
